"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _color = _interopRequireDefault(require("color"));

var _Link = _interopRequireDefault(require("./button/Link"));

var _Markdown = _interopRequireDefault(require("./text/Markdown"));

var _ScaleIn = _interopRequireDefault(require("./effect/animation/ScaleIn"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _styling = require("../toolkit/styling");

var _providers = require("../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Banner = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Banner, _Component);

  var _super = _createSuper(Banner);

  function Banner() {
    var _this;

    (0, _classCallCheck2["default"])(this, Banner);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(Banner, [{
    key: "renderContent",
    value: function renderContent() {
      var children = this.props.children;
      var text = this.props.text;

      if (!text) {
        return children;
      }

      if (typeof text != "string") {
        return text;
      }

      return /*#__PURE__*/_react["default"].createElement(_Markdown["default"], {
        text: text,
        className: (0, _styling.css)(this.styles.textContainer)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      var imageName = this.imageName,
          linkTitle = this.linkTitle,
          linkURL = this.linkURL,
          text = this.props.text;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.content)
      }, /*#__PURE__*/_react["default"].createElement(_ScaleIn["default"], {
        className: (0, _styling.css)(this.styles.iconWrapper)
      }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        name: imageName,
        className: (0, _styling.css)(this.styles.icon)
      })), this.renderContent(), text && linkURL && /*#__PURE__*/_react["default"].createElement(_Link["default"], {
        href: linkURL,
        openInNewTab: true,
        className: (0, _styling.css)(this.styles.linkContainer)
      }, linkTitle)));
    }
  }, {
    key: "imageName",
    get: function get() {
      var sentiment = this.props.sentiment;

      switch (sentiment) {
        case "success":
          return "cyanCheckmark";

        case "warning":
          return "yellowExclamation";

        case "error":
          return "redXSolid";

        case "info":
          return "greyI";

        default:
          return "greyI";
      }
    }
  }, {
    key: "color",
    get: function get() {
      var _this$context$theming = this.context.theming.theme,
          positive = _this$context$theming.positive,
          warning = _this$context$theming.warning,
          negative = _this$context$theming.negative,
          info = _this$context$theming.info;
      var sentiment = this.props.sentiment;

      switch (sentiment) {
        case "success":
          return positive;

        case "warning":
          return warning;

        case "error":
          return negative;

        case "info":
          return info;

        default:
          return positive;
      }
    }
  }, {
    key: "linkTitle",
    get: function get() {
      var link = this.props.link;

      if (link == null) {
        return null;
      }

      return link.title;
    }
  }, {
    key: "linkURL",
    get: function get() {
      var link = this.props.link;

      if (link == null) {
        return null;
      }

      return link.url;
    }
  }, {
    key: "rootAlignItems",
    get: function get() {
      var contentAlignment = this.props.contentAlignment;

      if (contentAlignment == "center") {
        return "center";
      }

      return "flex-start";
    }
  }, {
    key: "styles",
    get: function get() {
      var color = this.color,
          _this$props = this.props,
          showTopBorder = _this$props.showTopBorder,
          contentAlignment = _this$props.contentAlignment,
          iconVerticalAlignment = _this$props.iconVerticalAlignment,
          _this$context$theming2 = this.context.theming,
          _this$context$theming3 = _this$context$theming2.theme,
          positive = _this$context$theming3.positive,
          textBlack = _this$context$theming3.textBlack,
          fonts = _this$context$theming2.fonts;
      var backgroundLighteningFactor = color === positive ? 1.05 : 0.2;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "column",
          fontFamily: fonts.regular,
          alignItems: this.rootAlignItems,
          justifyContent: "center",
          backgroundColor: new _color["default"](color).lighten(backgroundLighteningFactor).string(),
          borderTop: showTopBorder ? "4px solid ".concat(color) : undefined
        },
        content: {
          alignItems: "center",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          padding: contentAlignment == "center" ? "13px 25px" : "13px 15px"
        },
        iconWrapper: {
          marginRight: 15,
          flexShrink: 0,
          alignSelf: iconVerticalAlignment == "top" ? "flex-start" : "center"
        },
        icon: {
          flexShrink: 0,
          width: 24,
          height: 24,
          marginTop: 2
        },
        linkContainer: {
          alignSelf: "center",
          padding: "0px 0px 0px 8px"
        },
        textContainer: {
          alignSelf: "center",
          color: textBlack,
          fontSize: 16,
          fontFamily: fonts.medium,
          textAlign: contentAlignment == "center" ? "center" : "left",
          lineHeight: 1.5
        }
      });
    }
  }]);
  return Banner;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.defaultProps = {
  contentAlignment: "center"
}, _class3.propDoc = {
  text: {
    required: true,
    type: "string | ReactNode",
    description: "Banner message"
  },
  sentiment: {
    required: true,
    type: "\"positive\" | \"negative\" | \"warning\" | \"info\"",
    description: "Sentiment of the message - determines the color treatment"
  },
  showTopBorder: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Set to hide the top border of the banner"
  },
  contentAlignment: {
    required: false,
    defaultValue: "center",
    type: "left | center",
    description: "Alignment of the text inside the banner"
  },
  iconVerticalAlignment: {
    required: false,
    defaultValue: "center",
    type: "top | center",
    description: "Vertical alignment of the icon inside the banner"
  }
}, _class3.demoProps = [{
  demoDescription: "success",
  sentiment: "success",
  text: "Your dispute has been submitted!"
}, {
  demoDescription: "warning",
  sentiment: "warning",
  text: "Vacation mode is on for your account and all your " + "products are currently not for sale."
}, {
  demoDescription: "error",
  sentiment: "error",
  text: "Your account must have 2FA enabled to receive payments from Wish."
}, {
  demoDescription: "info",
  sentiment: "info",
  text: "Finish opening up your store."
}, {
  demoDescription: "banner w/ link",
  sentiment: "success",
  text: "Your dispute has been submitted! [Learn More](http://www.google.com)"
}], _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "imageName", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "imageName"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "color", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "color"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "linkTitle", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "linkTitle"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "linkURL", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "linkURL"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "rootAlignItems", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "rootAlignItems"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

exports["default"] = Banner;